import { useQuery } from '@tanstack/react-query'
import {
  getTokenAnalyticsByWorkflow,
  getTokenAnalyticsByUser,
  getCopilotAnalyticsByWorkflow,
  getCopilotAnalyticsByUser,
} from '@/api/analytics'

const STALE_TIME = 5 * 60 * 1000

export function useTokenAnalyticsByWorkflow(
  projectId: string,
  params: { from?: string; to?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['analytics', 'token-usage', 'claude', 'by-workflow', projectId, params],
    queryFn: () => getTokenAnalyticsByWorkflow(projectId, params),
    staleTime: STALE_TIME,
    enabled: options?.enabled !== false,
  })
}

export function useTokenAnalyticsByUser(
  projectId: string,
  params: { from?: string; to?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['analytics', 'token-usage', 'claude', 'by-user', projectId, params],
    queryFn: () => getTokenAnalyticsByUser(projectId, params),
    staleTime: STALE_TIME,
    enabled: options?.enabled !== false,
  })
}

export function useCopilotAnalyticsByWorkflow(
  projectId: string,
  params: { from?: string; to?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['analytics', 'token-usage', 'copilot', 'by-workflow', projectId, params],
    queryFn: () => getCopilotAnalyticsByWorkflow(projectId, params),
    staleTime: STALE_TIME,
    enabled: options?.enabled !== false,
  })
}

export function useCopilotAnalyticsByUser(
  projectId: string,
  params: { from?: string; to?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['analytics', 'token-usage', 'copilot', 'by-user', projectId, params],
    queryFn: () => getCopilotAnalyticsByUser(projectId, params),
    staleTime: STALE_TIME,
    enabled: options?.enabled !== false,
  })
}
